// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__3M6p1","card__heading":"styles_card__heading__13aQ9","card__contentContainer":"styles_card__contentContainer__38vt6"};